module.exports = __webpack_public_path__ + "files/bfdfc96e1bef74e308d9130feef2bc2a.png";